export function initSection (obj, prop, func) {
  if (!obj.hasOwnProperty(prop)) {
    obj[prop] = func()
  }
}
